import {
  capitalize,
  ColorField,
  enumToOptions,
  FontSize,
  InputGroup,
  IOrganisationResponse as OrgResponse,
  removeHash,
  SelectField,
  TextArea,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import { IOrganisationPatchBody as OrgPatch } from '../../types/API'
import { Header, Section } from './WebShopHelper'

type Props = {
  values: OrgResponse
  handleChange: <K extends keyof OrgPatch>(key: K, value: OrgPatch[K]) => void
}
export default function AnnouncementBar(props: Props): ReactElement {
  const { values, handleChange } = props

  const selectedFontSize = {
    label: capitalize(values.textOnBackgroundSize),
    value: values.textOnBackgroundSize,
  }

  return (
    <Section>
      <Header>
        <h3>Announcement bar</h3>
        <p>
          Optionally add a banner above your webshop to advertise a promotion.
        </p>
      </Header>
      <TextArea
        className="card-section"
        label="Text"
        placeholder="Optionally add a small amount of text above your web shop..."
        maxChars={300}
        rows={4}
        onChange={(value): void => handleChange('introductoryText', value)}
        value={values.introductoryText}
      />
      <InputGroup style={{ marginTop: '7px' }}>
        <SelectField
          placeholder="Select a size..."
          options={enumToOptions(FontSize)}
          label="Text size"
          onChange={(option): void => {
            if (option) handleChange('textOnBackgroundSize', option.value)
          }}
          value={values.textOnBackgroundSize ? selectedFontSize : undefined}
        />
        <ColorField
          label="Text colour"
          onChange={(value): void => handleChange('colourTextOnBackground', removeHash(value))}
          value={values.colourTextOnBackground}
        />
        <ColorField
          label="Background colour"
          onChange={(value): void => handleChange('colourHeaderBackground', removeHash(value))}
          value={values.colourHeaderBackground}
        />
      </InputGroup>
    </Section>
  )
}
